import { ColumnConfig } from '@/components/table/Table';

export const userTableColumns: ColumnConfig[] = [
  { label: 'Nombre', field: 'fullName' },
  { label: 'Correo', field: 'email' },
  { label: 'Teléfono', field: 'phone' },
  { label: 'Dirección', field: 'address' },
];
